
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutDriverRating } from "./autogen/AutogenLayoutDriverRating";

const viewDriverRatingURL = "lme/settlement/DriverRating?mode=update&key=";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName:"driver_rating",
    screenName:"Driver Rating",
    navigateToUrl:viewDriverRatingURL
};
export class DriverRating extends AutogenLayoutDriverRating {

    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxDriverRating, DUPLICATE_VALIDATION_PROPS);
    }
}
